import { Skeleton } from "primereact/skeleton";

export function SyncSkeletons() {
  return (
    <div className="flex flex-column gap-2">
      <span className="text-600 text-sm mb-1">Updating modules...</span>
      <Skeleton width="100%" height="1rem" />
      <Skeleton width="90%" height="1rem" />
      <Skeleton width="95%" height="1rem" />
    </div>
  );
}
